import React from "react";
import {FaUserShield} from "react-icons/fa";
import ContentPage from "../../components/ContentPage";

const Privacy = () => (
	<ContentPage
		icon={<FaUserShield/>}
		eyebrow="YOUR DATA, CLEARLY EXPLAINED"
		title="Privacy Policy"
		summary="This policy explains what Barkr collects, why we use it, and the choices available to you."
		updated="Effective 10 June 2023">
		<h2>1. Information we collect</h2>
		<h3>1.1 Personal information</h3>
		<p>
			When you sign up for Barkr, we may collect information such as your name, email address,
			phone number, gender, approximate location, and profile photos. You can also choose to
			provide details about yourself and your dog.
		</p>
		<h3>1.2 Usage and device information</h3>
		<p>
			We may collect device information, log files, app interactions, and usage patterns. This
			helps us operate, secure, and improve Barkr.
		</p>
		<h3>1.3 Communications</h3>
		<p>
			When you use Barkr messaging, we may process and store messages and related information so
			we can provide chat, safety, moderation, and support features.
		</p>
		<h3>1.4 Third-party authentication</h3>
		<p>
			If you register through an available third-party account, we receive the information needed
			to authenticate you in accordance with that provider’s terms and your settings.
		</p>

		<h2>2. How we use information</h2>
		<ul>
			<li><strong>Personalization and matching:</strong> to recommend compatible nearby profiles and tailor your experience.</li>
			<li><strong>Communication:</strong> to deliver messages, service notices, and notifications you choose to receive.</li>
			<li><strong>Analytics and improvement:</strong> to understand usage and improve reliability, design, and features.</li>
			<li><strong>Safety and legal compliance:</strong> to prevent abuse, enforce our rules, and meet legal obligations.</li>
		</ul>

		<h2>3. When information is shared</h2>
		<h3>3.1 Service providers</h3>
		<p>
			We may use trusted providers for hosting, storage, analytics, communications, payments, and
			customer support. They may process information only as needed to provide those services.
		</p>
		<h3>3.2 Other Barkr members</h3>
		<p>
			Profile information you choose to publish—such as your name, photos, and dog details—may be
			visible to other members. Barkr displays approximate distance rather than your exact location.
		</p>
		<h3>3.3 Legal requirements</h3>
		<p>
			We may disclose information when required by law or when reasonably necessary to protect
			Barkr, our members, or the public from fraud, abuse, or other harm.
		</p>

		<h2>4. Data security</h2>
		<p>
			We use reasonable technical and organizational safeguards to protect personal information.
			No online system is completely secure, but we continually work to reduce risk and respond to
			security concerns.
		</p>

		<h2>5. Age requirements</h2>
		<p>
			Barkr is intended for adults. We do not knowingly collect personal information from children
			under 13. If you believe a child has provided information to Barkr, contact us so we can
			investigate and take appropriate action.
		</p>

		<h2>6. Account deletion</h2>
		<p>
			You can request deletion from Account settings in the app. We process eligible deletion
			requests and associated personal information in accordance with applicable requirements,
			including GDPR timelines where relevant.
		</p>

		<h2>7. Changes to this policy</h2>
		<p>
			We may update this policy to reflect changes to Barkr or our legal obligations. Material
			updates will be communicated through the app or another appropriate channel.
		</p>

		<h2>8. Contact us</h2>
		<p>
			Questions or requests about privacy can be sent to{" "}
			<a href="mailto:support@barkr.app">support@barkr.app</a>.
		</p>

		<div className="content-page__notice">
			By using Barkr, you acknowledge that you have read and understood this Privacy Policy.
		</div>
	</ContentPage>
);

export default Privacy;
